import { render, staticRenderFns } from "./BaseDropzone.vue?vue&type=template&id=a7bd4b60&scoped=true"
import script from "./BaseDropzone.vue?vue&type=script&lang=js"
export * from "./BaseDropzone.vue?vue&type=script&lang=js"
import style0 from "../../node_modules/bulma/css/bulma.css?vue&type=style&index=0&id=a7bd4b60&prod&lang=css&scoped=true&external"
import style1 from "./BaseDropzone.vue?vue&type=style&index=1&id=a7bd4b60&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bd4b60",
  null
  
)

export default component.exports